<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-user size="sm" variant="primary"><i class="mdi mdi-plus"></i> New User</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(role)="data">
                {{ data.item.role.name }}
              </template>
              <template #cell(actions)="data">
                <span v-if="data.item.username==userData.username">
                  <b-button @click="changepass(data.item.id,data.item.full_name)" type="button" class="btn-sm btn" variant="info" v-b-modal.password> <i class="mdi mdi-lock"></i> </b-button>
                </span>
                <span v-else>
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.full_name,data.item.contact,data.item.email_address,data.item.username,data.item.role.id )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="changepass(data.item.id,data.item.full_name)" type="button" class="btn-sm btn" variant="info" v-b-modal.password> <i class="mdi mdi-lock"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.full_name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </span>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-user" centered title="New System User" title-class="font-18" hide-footer>
        <form @submit.prevent="addUser">
            <div class="form-group mb-2">
            <label>Full Name</label>
            <input v-model="fullname" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Contact</label>
            <input v-model="contact" type="number" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Email Address</label>
            <input v-model="email" type="email" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Username</label> <span v-html="usernameerror"></span>
            <input v-model="username" type="text" @input="CheckUsername" class="form-control" />
             </div>
            <div class="form-group mb-2">
            <label>Password</label> <span v-html="passStrength"></span>
            <input v-model="password" type="password" @input="CheckPassword" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Role</label>
            <b-form-select v-model="role" :options="roles" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
            <!-- <multiselect v-model="role" label="name" valueProp="id" :options="roles"></multiselect> -->
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-user')" >Close</b-button>
                <b-button type="submit" :disabled="btnuser" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-user" centered title="Edit System User" title-class="font-14" hide-footer>
        <form @submit.prevent="editUser">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Full Name</label>
            <input v-model="fullname" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Contact</label>
            <input v-model="contact" type="number" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Email Address</label>
            <input v-model="email" type="email" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Username</label> <span v-html="usernameerror"></span>
            <input v-model="username" type="text" @input="CheckUsername" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Role</label>
            <b-form-select v-model="role" :options="roles" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-user')" >Close</b-button>
                <b-button type="submit" :disabled="btnuser" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="change-user" centered title="Change User Password" title-class="font-18" hide-footer>
        <form @submit.prevent="editUserPassword">
          <input v-model="id" type="hidden">
            <div class="form-group mb-2">
            <label>Password for <b>{{ fullname }}</b></label>
            <input v-model="password" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('change-user')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-user" centered title="Delete System User" title-class="font-18" hide-footer>
        <form @submit.prevent="removeUser">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the User : <b>{{ fullname }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-user')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { userMethods, userComputed,roleMethods, roleComputed } from "@/state/helpers";

export default {
  page: {
    title: "System Users",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Users",
      items: [ {text: "Dashboard",to: "/",}, {text: "System Users",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'full_name', label: 'Full Name', visible: true },
          { key: 'contact', label: 'Contact', visible: true },
          { key: 'email_address', label: 'Email address', visible: true },
          { key: 'username', label: 'Username', visible: true },
          { key: 'role', label: 'Role', visible: true },
          { key: 'roleId', label: 'RoleId', visible: false },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      fullname:'',
      contact:'',
      email:'',
      username:'',
      password:'',
      role:'',
      usernameerror:'',
      btnuser:false,
      passStrength:'',
    };
  },
  computed: {
    ...userComputed,
    ...roleComputed,
    List() { return this.users.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.users.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.users.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchUsers();
    this.fetchRoles();
    this.TotalRows = this.users.length;
    this.isBusy=false;
  },
  methods: {
    ...userMethods,
    ...roleMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,fullname,contact,email,username,role){
      this.id=id;
      this.fullname=fullname;
      this.contact=contact;
      this.email=email;
      this.username=username;
      this.role=role;
      this.$bvModal.show('edit-user')
    },
    changepass(id,fullname){
      this.id=id;
      this.fullname=fullname;
      this.$bvModal.show('change-user')
    },
    remove(id,fullname){
      this.id=id;
      this.fullname=fullname;
      this.$bvModal.show('delete-user')
    },
    async CheckPassword(){
      var strength = this.password.length;
      if (strength<5) {
        this.passStrength='<i class="text-danger small">Weak</i>';
        this.btnuser=true;
      } else {
        this.passStrength='<i class="text-primary small">Strong</i>';
        this.btnuser=false;
      }
    },
    async CheckUsername(){
      let formData = new FormData();
      formData.append("username", this.username);
      let url = "/checkusername";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        if (response.data==1) {
              this.usernameerror='<i class="text-danger small">Username Already Taken</i>';
              this.btnuser=true;
            }else{
              this.usernameerror="";
              this.btnuser=false;
            }
      }
    });
    },
    async addUser() { 
      let formData = new FormData();
      formData.append("fullname", this.fullname);
      formData.append("contact", this.contact);
      formData.append("email", this.email);
      formData.append("username", this.username);
      formData.append("password", this.password);
      formData.append("role", this.role);
      let url = "/addsystemuser";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchUsers();
          this.$bvModal.hide('new-user');
          this.fullname="";
          this.contact="";
          this.email="";
          this.username="";
          this.role="";
          this.password="";
      }
      });
    },
    async editUserPassword(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("password", this.password);
    let url = "/updateserpassword";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchUsers();
        this.$bvModal.hide('change-user');
      }
    });
    },
    async editUser(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("fullname", this.fullname);
    formData.append("contact", this.contact);
    formData.append("email", this.email);
    formData.append("username", this.username);
    formData.append("role", this.role);
    let url = "/updatesystemuser";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchUsers();
        this.$bvModal.hide('edit-user');
        this.fullname="";
        this.contact="";
        this.email="";
        this.username="";
        this.role="";
      }
    });
    },
    async removeUser() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removesystemuser";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchUsers();
        this.$bvModal.hide('delete-user');
      }
    });
    },
  },
};
</script>